import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * Configuración global de la aplicación
 */
export interface AppSettings {
  betaEnabled: boolean;
  maintenanceMode: boolean;
  allowRegistrations: boolean;
  aiEnabled: boolean;
  showAnalytics: boolean;
}

/**
 * Obtiene la configuración global de la aplicación
 */
export async function getAppSettings(): Promise<AppSettings> {
  try {
    const settingsDoc = await getDoc(doc(db, 'appSettings', 'global'));
    
    if (settingsDoc.exists()) {
      return settingsDoc.data() as AppSettings;
    }
    
    // Valores por defecto si no existe el documento
    return {
      betaEnabled: false,
      maintenanceMode: false,
      allowRegistrations: true,
      aiEnabled: true, // Por defecto activado
      showAnalytics: true, // Por defecto activado
    };
  } catch (error) {
    // En caso de error, asumir que está activado
    return {
      betaEnabled: false,
      maintenanceMode: false,
      allowRegistrations: true,
      aiEnabled: true,
      showAnalytics: true,
    };
  }
}

/**
 * Verifica si el generador de IA está habilitado globalmente
 */
export async function isAIEnabled(): Promise<boolean> {
  const settings = await getAppSettings();
  return settings.aiEnabled;
}
